export default __webpack_public_path__ + "static/media/ds02.86266adb.jpg";